import {
  AnyPgColumn,
  index,
  pgEnum,
  pgTable,
  uuid,
} from 'drizzle-orm/pg-core';
import { orders } from '@trashlab/api/src/domains/orders/schemas/orders';
import { defaultFields, defaultHistoryFields } from '@trashlab/api/drizzle/default';

export const rental_chain_status = pgEnum('rental_chain_status', [
  'SCHEDULED',
  'DELIVERED',
  'REMOVED',
]);

export const rental_chain = pgTable(
  'rental_chain',
  {
    ...defaultFields.fieldsWithTenantId(),
    customerId: uuid('customerId').notNull(),
    customerSiteId: uuid('customerSiteId').notNull(),
    status: rental_chain_status('status').default('SCHEDULED').notNull(),
    deliveryOrderId: uuid('deliveryOrderId').references(
      (): AnyPgColumn => orders.id,
    ),
    pickupOrderId: uuid('pickupOrderId').references(
      (): AnyPgColumn => orders.id,
    ),
  },
  (table) => {
    return {
      tenant_site_status_idx: index('rental_chain_site_status_idx').on(
        table.tenantId,
        table.customerSiteId,
        table.status,
      ),
      deliveryOrderId_idx: index('rental_chain_deliveryOrderId_idx').on(
        table.deliveryOrderId,
      ),
      pickupOrderId_idx: index('rental_chain_pickupOrderId_idx').on(
        table.pickupOrderId,
      ),
    };
  },
);

export const rental_chain_history = pgTable(
  'rental_chain_history',
  {
    ...defaultHistoryFields.historyFieldsWithTenantId(),
    customerId: uuid('customerId'),
    customerSiteId: uuid('customerSiteId'),
    status: rental_chain_status('status'),
    deliveryOrderId: uuid('deliveryOrderId'),
    pickupOrderId: uuid('pickupOrderId'),
  },
  (table) => {
    return {
      id_version_number_idx: index(
        'rental_chain_history_id_version_number_idx',
      ).on(table.id, table.versionNumber),
      customerSiteId_idx: index('rental_chain_history_customerSiteId_idx').on(
        table.customerSiteId,
      ),
      deliveryOrderId_idx: index('rental_chain_history_deliveryOrderId_idx').on(
        table.deliveryOrderId,
      ),
      pickupOrderId_idx: index('rental_chain_history_pickupOrderId_idx').on(
        table.pickupOrderId,
      ),
    };
  },
);

export type RentalChainSchema = typeof rental_chain.$inferSelect;


